export const FormIds = {
  PersonalInfo: "personal-info-form",
  ChangePassword: "change-password-form",
} as const;

export type FormIdsType = (typeof FormIds)[keyof typeof FormIds];

export const FormType = {
  create: "create",
  edit: "edit",
} as const;

export type FormTypeType = (typeof FormType)[keyof typeof FormType];

export const Roles = {
  SUPER_ADMIN: "super-admin",
  ADMIN: "admin",
  ANALITIK: "analitik",
  USER: "user",
  EDITOR: "editor",
} as const;

export type RolesType = (typeof Roles)[keyof typeof Roles];

/** Staff roles that can publish portfolios into the Ready-made gallery. */
export const READY_MADE_PORTFOLIO_ROLES: readonly RolesType[] = [
  Roles.SUPER_ADMIN,
  Roles.ADMIN,
  Roles.ANALITIK,
];

export const canManageReadyMadePortfolios = (
  roleName?: string,
): boolean =>
  !!roleName && (READY_MADE_PORTFOLIO_ROLES as readonly string[]).includes(roleName);

export type User = {
  id: string;
  client_type_id: string;
  role_id: string;
  first_name: string;
  last_name: string;
  surname: string;
  pinfl: string;
  email: string;
  phone: string;
  country: string;
  login: string;
  birth_date: string;
  gender: string;
  image: string;
  company: string;
  website: string;
  bio: string;
  note: string;
  twitter: string;
  linkedin: string;
  tags: null | string[];
  phone_verified: boolean;
  is_active: boolean;
  last_login: string;
  failed_login_attempts: number;
  locked_until: string;
  password_changed_at: string;
  two_factor_enabled: boolean;
  created_at: string;
  updated_at: string;
  role: {
    id: string;
    name: string;
    client_type_id: string;
    created_at: string;
    updated_at: string;
  };
};

/**
 * Interface representing feature limits and availability for a user.
 */
export interface UserFeature {
  enabled: boolean;
  limit: number;
  used: number;
  remaining: number;
}

/**
 * Interface representing the collection of all features for a user.
 * The key is the feature name (string).
 */
export interface UserFeatures {
  [featureName: string]: UserFeature;
}

/**
 * Interface for client/user type.
 */
export interface ClientType {
  id: string;
  name: string;
  created_at: string;
  updated_at: string;
}

/**
 * Full details for a user, including role, client type, subscription info and feature access.
 */
export interface UserDetails {
  user: User;
  role: {
    id: string;
    name: string;
    client_type_id: string;
    created_at: string;
    updated_at: string;
  };
  client_type: ClientType;
  has_pricing_plan: boolean;
  remaining_days: number;
  features: UserFeatures;
}
